import React from 'react';
import { ThemeProvider, CssBaseline, Box, GlobalStyles, Toolbar } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './styles/theme';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import AboutPage from './components/sections/About';
import ServicesPage from './components/sections/Services';
import ContactPage from './components/sections/Contact';
import HomePage from './components/sections/Home';
import Blog from './components/sections/Blog';
import BlogPost from './components/pages/BlogPost';
import ServicePage from './components/pages/ServicePage';
import NotFoundPage from './components/pages/NotFoundPage';
import { servicePages } from './servicePagesData';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <CssBaseline />
          <GlobalStyles
            styles={{
              html: {
                scrollBehavior: 'smooth',
              },
            }}
          />
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: 'transparent',
          }}>
            <Navbar />
            <Toolbar sx={{ minHeight: { xs: '82px !important', md: '96px !important' } }} />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<><Hero /><HomePage /></>} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                {servicePages.map((service) => (
                  <Route key={service.key} path={service.path} element={<ServicePage service={service} />} />
                ))}
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
          <Analytics />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
